import { all, takeLatest } from 'redux-saga/effects';
import { handleApiCall } from '../SagaUtils';

import { FETCH_USERS, IMPERSONATE_USER } from '../../constants/Constants';
import * as Api from '../../services/Api';

function* fetchUsers() {
  yield handleApiCall(FETCH_USERS, Api.fetchUsers, true);
}

function* fetchImpersonationUrl({ payload: { userId, apiClient } }) {
  yield handleApiCall(IMPERSONATE_USER, Api.impersonateUser, true, userId, apiClient);
}

function impersonateUser({ payload: { payload: { url } } }) {
  setTimeout(() => {
    window.location = url;
  }, 500);
}

export default function* usersSaga() {
  yield all([
    yield takeLatest(FETCH_USERS.REQUESTED, fetchUsers),
    yield takeLatest(IMPERSONATE_USER.REQUESTED, fetchImpersonationUrl),
    yield takeLatest(IMPERSONATE_USER.SUCCESS, impersonateUser)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/entities/UsersSaga.js